import { ACCENT } from '../../lib/uiTokens';

// Jednotná hlavička AOP vrstvy: číslovaný badge + „Vrstva N — {title}" + popis.
// Nahrazuje ručně kopírovaný blok v každé vrstvě (a sjednocuje číslování — dřív
// měla Energie badge „E" místo 4).
//
// Props:
//   krok      – číslo vrstvy (1–6) zobrazené v badge a v nadpisu
//   title     – název vrstvy bez prefixu „Vrstva N — "
//   cardStyle – styl karty (shora z Finance.jsx)
//   accent    – barva badge (default modulová modrá)
//   children  – popisný text vrstvy
export default function LayerHeader() {
    // Info dlaždice zrušena — krok/název je vidět v navigátoru vrstev nahoře,
    // tabulky tak dostanou víc místa a je to přehlednější. Volání ponechána
    // (renderují nic), ať se nemusí sahat do každé vrstvy.
    return null;
}
